import { colors } from '../../colors';
var input = {
  textColor: colors.nvaBlack
};
export default input;